import { render, staticRenderFns } from "./ItemTableList.vue?vue&type=template&id=b0328aa6&"
import script from "./ItemTableList.vue?vue&type=script&lang=ts&"
export * from "./ItemTableList.vue?vue&type=script&lang=ts&"
import style0 from "./ItemTableList.vue?vue&type=style&index=0&id=b0328aa6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports